/* eslint-disable no-useless-concat */
import { ERROR_CODES } from '@vodafoneis/sjonvarpskjarni-js-lib';

export default class Error {
	static getErrorMessage(code) {
		switch (code) {
			case ERROR_CODES.ERROR_USERNAME_NOT_FOUND:
				return 'Gat ekki fundið notandanafn fyrir þetta símanúmer. ' + 'Þú verður að nota sama símanúmer og þú notaðir við nýskráningu.';
			case ERROR_CODES.ERROR_INVALID_SMS_CODE:
				return 'SMS kóði rangur.';
			case ERROR_CODES.ERROR_PASSWORD_INVALID:
				return 'Lykilorðið þarf að innihalda stóran staf, ' + 'lítinn staf og tölustaf, auk þess að vera að lágmarki 8 stafir að lengd.';
			case ERROR_CODES.ERROR_EMAIL_INVALID:
				return 'Þetta netfang er ekki gilt.';
			case ERROR_CODES.ERROR_SSN_INVALID:
			case ERROR_CODES.ERROR_SSN_NOT_IN_NATIONAL_REGISTRY:
				return 'Þessi kennitala er ekki gild.';
			case ERROR_CODES.ERROR_SSN_NOT_INDIVIDUAL:
				return 'Eingöngu er leyfilegt að nota kennitölur einstaklinga.';
			case ERROR_CODES.ERROR_SSN_NOT_OVER_18:
				return 'Yngri en 18 ára geta ekki nýskráð sig.';
			case ERROR_CODES.ERROR_PHONE_NUMBER_IN_USE:
				return 'Aðgangur nú þegar til. Vinsamlegast skráðu þig inn.';
			case ERROR_CODES.ERROR_PHONE_NUMBER_INVALID:
				return 'Símanúmer ekki gilt. Eingöngu íslensk farsímanúmer eru leyfð.';
			case ERROR_CODES.ERROR_MAX_TRIES_EXCEEDED:
				return 'Of margar tilraunir, reyndu aftur síðar.';
			case ERROR_CODES.ERROR_SESSION_EXPIRED:
				return 'Tími útrunninn, vinsamlegast byrjaðu upp á nýtt.';
			case ERROR_CODES.ERROR_CREATE_ACCOUNT_FAILED:
				return 'Gat ekki stofnað notanda. Hafðu samband við ' + 'Þjónustuver Sýnar í síma 1414 ef vandamálið er viðvarandi.';
			case ERROR_CODES.ERROR_UPDATE_PASSWORD_FAILED:
				return 'Gat ekki uppfært lykilorð. Hafðu samband við ' + 'Þjónustuver Sýnar í síma 1414 ef vandamálið er viðvarandi.';
			default:
				return 'Villa kom upp, vinsamlegast reyndu aftur síðar. Hafðu samband við ' + 'Þjónustuver Sýnar í síma 1414 ef vandamálið er viðvarandi.';
		}
	}
}
